import { useMemo } from 'react';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { useSpaceManagementOperations } from '@confluence/space-utils/entry-points/graphql.ts';
import { usePageSpaceKey } from '@confluence/page-context';

import { useSPAViewContext } from './content-ownership-helpers.ts';

export const useIsAllowedToChangeOwner = (ownedByAccountId: string | null): boolean => {
	const { userId } = useSessionData();
	const [spaceKey] = usePageSpaceKey();
	const { isSiteAdmin } = useSPAViewContext();
	const { canManageContent = false } =
		useSpaceManagementOperations({
			spaceKey: spaceKey ?? '',
			skip: !spaceKey,
		}) ?? {};

	// MANAGE_CONTENT does not include the site-admin fallback that MANAGE_USERS has.
	const isElevated = canManageContent || isSiteAdmin;

	return useMemo(() => {
		if (!userId) {
			return false;
		}
		const isCurrentUserOwner = ownedByAccountId === userId;
		return isElevated || isCurrentUserOwner;
	}, [isElevated, ownedByAccountId, userId]);
};
